'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var CheckMarkIcon = require('@narvar/nth-bit-icon-check-mark');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthKitDynamicLayoutNext = require('@narvar/nth-kit-dynamic-layout-next');
var types = require('../../types.js');
var LineLogo = require('../common/LineLogo.js');
var ControlView = require('../ControlView/ControlView.js');
var nthHookGrowthbook = require('@narvar/nth-hook-growthbook');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var CheckMarkIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckMarkIcon);

const {
  FeatureLayout
} = nthKitDynamicLayoutNext.LayoutTree;
const Subscribed = ({
  onUpdateContactInfo,
  onUnsubscribe,
  featureName,
  layout,
  channel,
  notificationPreferencesState
}) => {
  const {
    orderLevelOptInEnabled,
    retailerLevelOptInEnabled,
    retailerName
  } = nthHookGlobalSettings.useGlobalSettings();
  const {
    preferenceLevel
  } = notificationPreferencesState || {};
  const retailerLevel = preferenceLevel === types.PreferenceLevels.RETAILER;
  const {
    notificationCenterSmsUpdateNumberMessage,
    notificationCenterSmsUpdateNumberButton,
    notificationCenterSmsOptoutLink,
    notificationCenterAppPushUpdateMessage,
    notificationCenterEmailUpdateMessage,
    notificationCenterEmailUpdateButton,
    notificationCenterEmailOptoutLink,
    notificationCenterLineUpdateMessage,
    notificationCenterLineOptoutLink,
    notificationCenterLineOptoutLinkRetailerLevel,
    notificationCenterLineUpdateMessageRetailerLevel,
    notificationCenterSmsUpdateNumberMessageRetailerLevel,
    notificationCenterSmsOptoutLinkRetailerLevel,
    notificationCenterEmailUpdateMessageRetailerLevel,
    notificationCenterEmailOptoutLinkRetailerLevel,
    notificationCenterSublimeManageYourPreferences,
    notificationCenterSublimeAutoOptinTitle,
    notificationCenterSublimeAutoOptinText,
    notificationCenterSublimeUnsubscribeFromAll
  } = nthHookTranslations.useTranslations();
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const isLandscape = layout === FeatureLayout.LANDSCAPE;
  const smsSubscribedChannelProps = {
    updateContactInfoIcon: /*#__PURE__*/React__default["default"].createElement(CheckMarkIcon__default["default"], {
      featureName: featureName
    }),
    updateContactInfoMessage: (retailerLevel ? mustache__default["default"].render(notificationCenterSmsUpdateNumberMessageRetailerLevel || '', {
      retailerName
    }) : notificationCenterSmsUpdateNumberMessage) || '',
    updateContactInfoButtonText: notificationCenterSmsUpdateNumberButton || '',
    unsubscribeLink: (retailerLevel ? mustache__default["default"].render(notificationCenterSmsOptoutLinkRetailerLevel || '', {
      retailerName
    }) : notificationCenterSmsOptoutLink) || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_NOTIFICATION_CENTER,
    eventCategory: nthHookContextAnalytics.NarvarClickSubTypes.SMS_NUMBER_UPDATE,
    unsubscribeEvent: nthHookContextAnalytics.NarvarClickSubTypes.SMS_UNSUBSCRIBE
  };
  const appPushSubscribedChannelProps = {
    updateContactInfoIcon: /*#__PURE__*/React__default["default"].createElement(CheckMarkIcon__default["default"], {
      featureName: featureName
    }),
    updateContactInfoMessage: notificationCenterAppPushUpdateMessage || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_APP_PUSH_NOTIFICATION_CENTER
  };
  const emailSubscribedChannelProps = {
    updateContactInfoIcon: /*#__PURE__*/React__default["default"].createElement(CheckMarkIcon__default["default"], {
      featureName: featureName
    }),
    updateContactInfoMessage: (retailerLevel ? mustache__default["default"].render(notificationCenterEmailUpdateMessageRetailerLevel || '', {
      retailerName
    }) : notificationCenterEmailUpdateMessage) || '',
    updateContactInfoButtonText: notificationCenterEmailUpdateButton || '',
    unsubscribeLink: (retailerLevel ? mustache__default["default"].render(notificationCenterEmailOptoutLinkRetailerLevel || '', {
      retailerName
    }) : notificationCenterEmailOptoutLink) || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_EMAIL_NOTIFICATION_CENTER,
    eventCategory: nthHookContextAnalytics.NarvarClickSubTypes.EMAIL_UPDATE,
    unsubscribeEvent: nthHookContextAnalytics.NarvarClickSubTypes.EMAIL_UNSUBSCRIBE
  };
  const lineSubscribedChannelProps = {
    updateContactInfoIcon: /*#__PURE__*/React__default["default"].createElement(LineLogo["default"], null),
    updateContactInfoMessage: (retailerLevel ? mustache__default["default"].render(notificationCenterLineUpdateMessageRetailerLevel || '', {
      retailerName
    }) : notificationCenterLineUpdateMessage) || '',
    updateContactInfoButtonText: '',
    unsubscribeLink: (retailerLevel ? mustache__default["default"].render(notificationCenterLineOptoutLinkRetailerLevel || '', {
      retailerName
    }) : notificationCenterLineOptoutLink) || '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_LINE_NOTIFICATION_CENTER,
    unsubscribeEvent: nthHookContextAnalytics.NarvarClickSubTypes.LINE_UNSUBSCRIBE
  };
  const sublimeSubscribedSubscribedChannelProps = {
    updateContactInfoIcon: /*#__PURE__*/React__default["default"].createElement(CheckMarkIcon__default["default"], {
      featureName: featureName
    }),
    updateContactInfoMessage: notificationCenterSublimeAutoOptinTitle ?? '',
    updateContextInfoText: notificationCenterSublimeAutoOptinText ?? '',
    updateContactInfoButtonText: notificationCenterSublimeManageYourPreferences ?? '',
    unsubscribeLink: notificationCenterSublimeUnsubscribeFromAll ?? '',
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_LINE_NOTIFICATION_CENTER,
    unsubscribeEvent: nthHookContextAnalytics.NarvarClickSubTypes.LINE_UNSUBSCRIBE
  };
  const subscribedChannelProps = {
    [types.Channels.SMS]: smsSubscribedChannelProps,
    [types.Channels.HIPAA_SMS]: smsSubscribedChannelProps,
    [types.Channels.EMAIL]: emailSubscribedChannelProps,
    [types.Channels.HIPAA_EMAIL]: emailSubscribedChannelProps,
    [types.Channels.APP_PUSH]: appPushSubscribedChannelProps,
    [types.Channels.LINE]: lineSubscribedChannelProps,
    [types.Channels.SUBLIME]: sublimeSubscribedSubscribedChannelProps
  };
  const {
    updateContactInfoIcon,
    updateContactInfoMessage,
    updateContextInfoText,
    updateContactInfoButtonText,
    unsubscribeLink,
    eventComponent,
    eventCategory,
    unsubscribeEvent
  } = subscribedChannelProps[channel];
  const handlePrimaryButtonClick = () => {
    logEvent({
      clickCategory: eventCategory,
      clickNotificationIsChangeNumber: true,
      clickSubType: eventCategory,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent,
      eventFeature: eventComponent,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: eventComponent
    });
    onUpdateContactInfo();
  };
  const handleSecondaryButtonClick = () => {
    onUnsubscribe();
    logEvent({
      clickCategory: unsubscribeEvent,
      clickNotificationIsOptOut: true,
      clickSubType: unsubscribeEvent,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent,
      eventFeature: eventComponent,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: eventComponent
    });
  };
  const {
    enabled: notificationPreferencesUnsubscribeEnabled
  } = nthHookGrowthbook.useIsTrackFeatureOn('notification-preferences-unsubscribe');
  const retailerPreference = preferenceLevel === types.PreferenceLevels.RETAILER;
  const orderPreference = preferenceLevel === types.PreferenceLevels.ORDER;
  const getShowSubscribeActions = () => {
    const subscribeActions = {
      showUnsubscribeAction: true,
      showUpdateAction: true
    };
    if (retailerPreference && !retailerLevelOptInEnabled || orderPreference && !orderLevelOptInEnabled || channel === types.Channels.APP_PUSH) {
      subscribeActions.showUnsubscribeAction = false;
      subscribeActions.showUpdateAction = false;
    }
    if (channel === types.Channels.LINE) {
      subscribeActions.showUpdateAction = false;
    }
    if (channel === types.Channels.SUBLIME && !notificationPreferencesUnsubscribeEnabled) {
      subscribeActions.showUnsubscribeAction = false;
    }
    return subscribeActions;
  };
  const {
    showUpdateAction,
    showUnsubscribeAction
  } = getShowSubscribeActions();
  return /*#__PURE__*/React__default["default"].createElement(ControlView["default"], {
    featureName: featureName,
    isLandscape: isLandscape,
    channel: channel,
    icon: updateContactInfoIcon,
    heading: updateContactInfoMessage,
    text: updateContextInfoText,
    primaryButton: showUpdateAction ? {
      onClick: handlePrimaryButtonClick,
      text: updateContactInfoButtonText ?? ''
    } : undefined,
    secondaryButton: showUnsubscribeAction ? {
      onClick: handleSecondaryButtonClick,
      text: unsubscribeLink ?? ''
    } : undefined
  });
};
var Subscribed$1 = nthHookGlobalSettings.withGlobalSettingsProvider(nthHookTranslations.withTranslationsProvider(Subscribed, {
  translationKeys: ['notificationCenterSmsUpdateNumberMessage', 'notificationCenterSmsUpdateNumberButton', 'notificationCenterSmsOptoutLink', 'notificationCenterAppPushUpdateMessage', 'notificationCenterEmailUpdateMessage', 'notificationCenterEmailUpdateButton', 'notificationCenterEmailOptoutLink', 'notificationCenterLineUpdateMessage', 'notificationCenterLineOptoutLink', 'notificationCenterLineOptoutLinkRetailerLevel', 'notificationCenterLineUpdateMessageRetailerLevel', 'notificationCenterSmsUpdateNumberMessageRetailerLevel', 'notificationCenterSmsOptoutLinkRetailerLevel', 'notificationCenterEmailUpdateMessageRetailerLevel', 'notificationCenterEmailOptoutLinkRetailerLevel', 'notificationCenterSublimeManageYourPreferences', 'notificationCenterSublimeAutoOptinTitle', 'notificationCenterSublimeAutoOptinText', 'notificationCenterSublimeUnsubscribeFromAll']
}), {
  globalSettingsRequested: `
      orderLevelOptInEnabled
      retailerLevelOptInEnabled
      retailerName
    `
});

exports["default"] = Subscribed$1;
